import { render, staticRenderFns } from "./RptRentRevenue.vue?vue&type=template&id=0c13270e&scoped=true&"
import script from "./RptRentRevenue.vue?vue&type=script&lang=js&"
export * from "./RptRentRevenue.vue?vue&type=script&lang=js&"
import style0 from "./RptRentRevenue.vue?vue&type=style&index=0&id=0c13270e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c13270e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDataTable,VRow,VTextField})
